// Better Auth stores multiple roles comma-separated ("user,admin").
export const roles = (user: { role?: string | null }) => user.role?.split(',').map((r) => r.trim()).filter(Boolean) ?? []
